<!-- Объекты верх -->
<div class="tabpage objects flex flex-column" [attr.id]="rootID" *ngIf="!hiddenMode">
  <app-objects-filter></app-objects-filter>
  <div class="choosegroup dropdown dropclick"
       [style]="{display: groupObjectsByGroups ? 'none': 'block'}"
       [attr.id]="groupRootID"
  >
    <input type="text" readonly="readonly" />
    <div class="dropcontent dontclose">
      <div class="dropcontentinset">
        <!-- button class="btnaddgroup">{{ 'Add' | translate }}</button-->
        <input type="text" class="searchinput" placeholder="{{ 'Group search'| translate }}" />
        <ul></ul>
      </div>
    </div>
    <div class="objdropdown dropdown dropclick dropclickjs">
      <ul>
        <li>{{ 'Select' | translate }}</li>
      </ul>
    </div>
  </div>
  <div class="tableheader">
    <input type="checkbox">
    <label class="check_img check_sortaz"  title="{{ 'Sorting order' | translate }}"><input type="checkbox"><span></span></label>
    <label class="check_img group_objects" title="{{ 'Grouping' | translate }}"><input type="checkbox"><span></span></label>
    <label class="check_img selected_objects" title="{{ 'Hide unselected' | translate }}"><input type="checkbox"><span></span></label>

    <label *ngIf="trackingMode" class="check_img check_wifi" title="{{ 'Show only online devices' | translate }}"><input type="checkbox"><span></span></label>
    <label *ngIf="trackingMode" class="check_img check_alert" title="{{ 'Show only devices with alarms' | translate }}"><input type="checkbox"><span></span></label>
    <label *ngIf="trackingMode" class="check_img check_parking" title="{{ 'Show only parked devices' | translate }}"><input type="checkbox"><span></span></label>
    <label *ngIf="trackingMode" class="check_img check_speed" title="{{ 'Show only moving devices' | translate }}"><input type="checkbox"><span></span></label>
  </div>
  <div class="tablewrap flex-1">
    <div class="table">
      <table [attr.id]="listRootID">
      </table>
      <div class="objdropdown dropdown dropclick dropclickjs devicemenu">
        <ul>
          <li>{{ 'Show on the map' | translate }}</li>
          <li class="send_command">{{ 'Send command to device' | translate }}</li>
          <li>{{ 'Show photos from device' | translate }}</li>
          <li class="separator" *ngIf="canEditObjects"></li>
          <li [class.edit_object]="canEditObjects" [class.disabled]="!canEditObjects" [attr.aria-disabled]="!canEditObjects">{{ 'Edit' | translate }}</li>
          <li [class.sync_object]="canEditObjects" [class.disabled]="!canEditObjects" [attr.aria-disabled]="!canEditObjects">{{ 'Synchronize keys' | translate }}</li>
        </ul>
      </div>
    </div>
  </div>

  <app-pagination [viewmode]="'pages hideitemscount'" [ngClass]="pagerClass"></app-pagination>
</div>
